/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TOKEN_KEY } from '../../Utils/Constants';
import { baseUrl } from '../../shared/baseUrl';
import ItemCard from '../Common/Item/ItemCard';
import NoItems from '../Common/NoItems';
import SectionHead from '../Common/SectionHead';
import ShimmerCard from '../Common/Shimmer/ShimmerCard';

const UserAllProduct = () => {

  const [product, setProduct] = useState([]);
  const [isLoading, setIsLoading] = useState(true)
  const { sname, sid } = useParams()

  const fetchData = async () => {
    try {
      const res = await fetch(`${baseUrl}products-from-seller?seller_id=${sid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem(TOKEN_KEY)
            ? 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            : null,
        },
      });
      const data = await res.json();
      setIsLoading(false)
      setProduct(data.data.data)

    } catch (error) {
      console.error('Error');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData()
  }, [sid]);

  return (

    <div className='mt-4 container'>
      {/* <UserDetails/> */}
      <SectionHead
        leadFirstLabel={`${sname}'s`}
        leadSecondLabel="Products"
      />

      <div className="d-flex flex-wrap">
        {isLoading ? (
          <>
            {Array(4)
              .fill()
              .map((_, index) => {
                return (
                  <ShimmerCard
                    key={index}
                    clsName="col-6 col-md-4 col-lg-3"
                    index={index}
                  />
                );
              })}
          </>
        ) : (
          <>
            {product.length > 0 ? (
              product.map((product, index) => (
                <ItemCard item={product} key={index} clsName="col-6 col-md-4 col-lg-3" index={index} />
              ))
            ) : (
              <NoItems />
            )}

          </>
        )
        }

      </div>
    </div>
  );
};

export default UserAllProduct;






